import { render } from "./OrderNotesModal.vue?vue&type=template&id=549bcc72"
import script from "./OrderNotesModal.vue?vue&type=script&lang=js"
export * from "./OrderNotesModal.vue?vue&type=script&lang=js"

import "./OrderNotesModal.vue?vue&type=style&index=0&id=549bcc72&lang=scss"
script.render = render

export default script